/* ===========================================================================
   Select
   =========================================================================== */

import 'select2/dist/js/select2.js';
import 'select2/dist/js/i18n/fr.js';

const $select2 = $('.js-select2');
const $itemFilter = document.getElementById('js-item-filter');

if ($select2) {
  $select2.select2({
    language: 'fr'
  });
}

if ($itemFilter) {
  $select2.on('select2:select', function(e) {
    const item = new Item();
    item.filter();
  });
}
